"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
const manager_1 = require("../manager");
const booleanClass_1 = require("../class/booleanClass");
exports.ifStatement = ({ ast, execObject }) => {
    const condition = execObject.interpreter({
        ast: ast.children.conditionalExpression[0],
        execObject,
    });
    const bool = booleanClass_1.toBoolean(condition);
    if (bool.image === tokens_1.BooleanLiteralTokens.true) {
        return execObject.interpreter({
            ast: ast.children.rules[0],
            execObject: {
                manager: { variable: new manager_1.VariableManager(execObject.manager.variable), function: execObject.manager.function },
                interpreter: execObject.interpreter,
            },
        });
    }
    else if (ast.children.rules.length >= 2) {
        return execObject.interpreter({
            ast: ast.children.rules[1],
            execObject: {
                manager: { variable: new manager_1.VariableManager(execObject.manager.variable), function: execObject.manager.function },
                interpreter: execObject.interpreter,
            },
        });
    }
};
